/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { PortalItemResponse } from './PortalItemResponse';
import {
    PortalItemResponseFromJSON,
    PortalItemResponseFromJSONTyped,
    PortalItemResponseToJSON,
    PortalItemResponseToJSONTyped,
} from './PortalItemResponse';
import type { PortalItemDisplayStatus } from './PortalItemDisplayStatus';
import {
    PortalItemDisplayStatusFromJSON,
    PortalItemDisplayStatusFromJSONTyped,
    PortalItemDisplayStatusToJSON,
    PortalItemDisplayStatusToJSONTyped,
} from './PortalItemDisplayStatus';

/**
 * 
 * @export
 * @interface PortalRequestItem
 */
export interface PortalRequestItem {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    label: string;
    /**
     * 
     */
    instructions: string | null;
    /**
     * 
     */
    participant_reason: string | null;
    /**
     * 
     */
    item_group: string | null;
    /**
     * 
     */
    due_at: Date | null;
    /**
     * 
     */
    sort_order: number;
    /**
     * 
     */
    display_status: PortalItemDisplayStatus;
    /**
     * The participant-facing reason from the latest Ask for Another Look
     */
    staff_note: string | null;
    /**
     * 
     */
    my_document_count: number;
    /**
     * 
     */
    my_response: PortalItemResponse | null;
}



/**
 * Check if a given object implements the PortalRequestItem interface.
 */
export function instanceOfPortalRequestItem(value: object): value is PortalRequestItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('instructions' in value) || value['instructions'] === undefined) return false;
    if (!('participant_reason' in value) || value['participant_reason'] === undefined) return false;
    if (!('item_group' in value) || value['item_group'] === undefined) return false;
    if (!('due_at' in value) || value['due_at'] === undefined) return false;
    if (!('sort_order' in value) || value['sort_order'] === undefined) return false;
    if (!('display_status' in value) || value['display_status'] === undefined) return false;
    if (!('staff_note' in value) || value['staff_note'] === undefined) return false;
    if (!('my_document_count' in value) || value['my_document_count'] === undefined) return false;
    if (!('my_response' in value) || value['my_response'] === undefined) return false;
    return true;
}

export function PortalRequestItemFromJSON(json: any): PortalRequestItem {
    return PortalRequestItemFromJSONTyped(json, false);
}

export function PortalRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'instructions': json['instructions'],
        'participant_reason': json['participant_reason'],
        'item_group': json['item_group'],
        'due_at': (json['due_at'] == null ? null : parseDateTime(json['due_at'])),
        'sort_order': json['sort_order'],
        'display_status': PortalItemDisplayStatusFromJSON(json['display_status']),
        'staff_note': json['staff_note'],
        'my_document_count': json['my_document_count'],
        'my_response': PortalItemResponseFromJSON(json['my_response']),
    };
}

export function PortalRequestItemToJSON(json: any): PortalRequestItem {
    return PortalRequestItemToJSONTyped(json, false);
}

export function PortalRequestItemToJSONTyped(value?: PortalRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'instructions': value['instructions'],
        'participant_reason': value['participant_reason'],
        'item_group': value['item_group'],
        'due_at': value['due_at'] == null ? value['due_at'] : serializeDateTime(value['due_at']),
        'sort_order': value['sort_order'],
        'display_status': PortalItemDisplayStatusToJSON(value['display_status']),
        'staff_note': value['staff_note'],
        'my_document_count': value['my_document_count'],
        'my_response': PortalItemResponseToJSON(value['my_response']),
    };
}

